// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151307/js/" + chunkId + "." + {"44":"5029b7bf","225":"e1fdf8a2","481":"eef7a751","486":"8581d87a","770":"89096aed"}[chunkId] + ".0.9815453509914194.chunk.js";
};